<template>
  <div class="form-group">
    <p class="form-text">
      {{ __('Para configurar a integração do Bulldesk com o Olark, basta seguir os passos em') }}
      <a
        href="https://www.olark.com/help/webhooks"
        target="_blank"
      >
        https://www.olark.com/help/webhooks</a>.
    </p>
    <label class="lg">URL Webhook</label>
    <p>
      <input
        type="text"
        :value="token"
        class="form-control"
        readonly
      >
    </p>
  </div>
</template>

<script>
export default {
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },

  computed: {
    token () {
      return `https://${document.domain}/hook/olark/${this.integration.public_token}`;
    },
  },

};
</script>

<style>

</style>
